import { render, staticRenderFns } from "./Results.vue?vue&type=template&id=2d0aca5c&scoped=true&"
import script from "./Results.vue?vue&type=script&lang=js&"
export * from "./Results.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/common.css?vue&type=style&index=0&id=2d0aca5c&scoped=true&lang=css&"
import style1 from "./Results.vue?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/css/Advanced.css?vue&type=style&index=2&id=2d0aca5c&scoped=true&lang=css&"
import style3 from "./Results.vue?vue&type=style&index=3&id=2d0aca5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0aca5c",
  null
  
)

export default component.exports